import React from 'react';
import PropTypes from 'prop-types';

const StoringenRow = (props) => {
  const { children } = props;
  return (
    <div className="storingen-form__row">
      <div className="storingen-form__route">{children[0]}</div>
      <div className="storingen-form__date-and-submit">
        <div className="storingen-form__date">{children[1]}</div>
        <div className="storingen-form__submit-btn">{children[2]}</div>
      </div>
    </div>
  );
};

StoringenRow.propTypes = {
  config: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired
};

export default StoringenRow;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/StoringenRow.js